import { BLOCKQUOTE } from 'ricos-content';
import { Node_Type } from 'ricos-schema';
import type { TiptapEditorPlugin } from 'ricos-types';
import { createShortcut } from 'ricos-types';
import { RESOLVERS_IDS } from 'wix-rich-content-toolbars-v3/libs/resolvers-ids';

import BlockQuoteIcon from './BlockQuoteIcon';
import { BLOCKQUOTE_BUTTON_DATA_HOOK } from './data-hooks';
import { blockquote } from './extension';

export const pluginBlockquote: TiptapEditorPlugin = {
  type: Node_Type.BLOCKQUOTE,
  config: {},
  tiptapExtensions: [blockquote],
  shortcuts: [
    createShortcut({
      name: Node_Type.BLOCKQUOTE,
      description: 'ShortcutsSheet_Formatting_Quote',
      keys: { macOs: 'Meta+Shift+9', windows: 'Ctrl+Shift+9' },
      command({ editorCommands }) {
        editorCommands.setBlockType(BLOCKQUOTE);
      },
      group: 'ShortcutsSheet_Section_Formatting',
      enabled: true,
    }),
  ],
  textButtons: [
    {
      id: Node_Type.BLOCKQUOTE,
      type: 'toggle',
      presentation: {
        dataHook: BLOCKQUOTE_BUTTON_DATA_HOOK,
        tooltip: 'QuoteButton_Tooltip',
        icon: BlockQuoteIcon,
      },
      attributes: {
        visible: RESOLVERS_IDS.ALWAYS_VISIBLE,
        active: RESOLVERS_IDS.IS_TEXT_CONTAINS_QUOTE,
        disabled: RESOLVERS_IDS.IS_NODE_SELECTED,
      },
      command:
        ({ editorCommands }) =>
        () => {
          editorCommands.setBlockType(BLOCKQUOTE);
          return true;
        },
    },
  ],
};
